'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import UserStore from '../../../stores/UserStore';

import { conditionNamesToSpecialName } from '../../../utils/Conditions';
import allConditions from '../../../tables/conditions';

export default class MyPrescription extends Component {

    clearPrescription = (filterName) => {
        const { params, onChangeParams } = this.props;

        // Are there any avoidances associated with this prescription? Remove them from the parameters
        const user = UserStore.getUser();
        let removeAvoidances = [];

        // This adds all avoidances from the users conditions to the skip list, so we don't show them
        // in addition to the my prescription filter param.
        let { conditions = [] } = (user || {});
        conditions.map(c => allConditions.filter(cd => cd.name == c.name)[0]).filter(v => v)
                  .forEach(({avoidances = []}) => {
                      avoidances.forEach(avoidance => !removeAvoidances.includes(avoidance) && removeAvoidances.push(avoidance))
                  });

        // Remove all the avoidances that come from conditions from the avoidance list.
        params.filters['!ingredient_tags'] = (params.filters['!ingredient_tags'] || []).filter(avoids => !removeAvoidances.includes(avoids));

        // Finally, remove the prescription constraints themselves.
        delete params.filters[filterName];

        onChangeParams(params, true);
    }

    render() {
        const { params = {} } = this.props;
        const { filters = {} } = params;
        const user = UserStore.getUser();

        const conditions = user ? (user.conditions || []).map(c => c.name) : [];
        const { hide_nutrition = false } = (user && user.preferences) || {};
        const specialNames = conditionNamesToSpecialName(conditions);

        const items = [];

        if (user && filters.prescriptions) {
            items.push(
                <div className="param-item" onClick={() => this.clearPrescription('prescriptions')} key="prescriptions">
                    Fits {specialNames.length && !hide_nutrition ? specialNames.join(', ') : 'Your Prescription'} <i className="icon-close-x" />
                </div>
            );
        }

        if (user && filters.strict_rx) {
            items.push(
                <div className="param-item" onClick={() => this.clearPrescription('strict_rx')} key="strict_rx">
                    Standalones Fitting Rx <i className="icon-close-x" />
                </div>
            );

        }

        return (
            <span>{items}</span>
        );
    }
}
